module.exports = __webpack_public_path__ + "img/sunmi_white.6da4d5db.png";